import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "d-flex col-lg-8 fv-row" }
const _hoisted_10 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitPullButton",
  class: "btn btn-primary flex-shrink-0"
}
const _hoisted_11 = { class: "indicator-label" }
const _hoisted_12 = { class: "indicator-progress" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_14 = { class: "fv-plugins-message-container position-absolute top-10 start-50" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "collapse show mt-5" }
const _hoisted_17 = { class: "card-body p-9" }
const _hoisted_18 = { class: "row mb-6" }
const _hoisted_19 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_20 = { class: "col-lg-8 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = { class: "fv-plugins-message-container" }
const _hoisted_42 = { class: "fv-help-block" }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "row mb-6" }
const _hoisted_49 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_50 = { class: "col-lg-8 fv-row" }
const _hoisted_51 = { class: "fv-plugins-message-container" }
const _hoisted_52 = { class: "fv-help-block" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_55 = { class: "col-lg-8 fv-row" }
const _hoisted_56 = { class: "fv-plugins-message-container" }
const _hoisted_57 = { class: "fv-help-block" }
const _hoisted_58 = { class: "row mb-6" }
const _hoisted_59 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_60 = { class: "col-lg-8 fv-row" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = { class: "col-lg-8 fv-row" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_68 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_69 = { class: "indicator-label" }
const _hoisted_70 = { class: "indicator-progress" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'assets'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewNews')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            "validation-schema": _ctx.urlSchema,
            onSubmit: _ctx.onSubmitPull
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('url')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "url",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid me-3",
                      placeholder: _ctx.translate('url')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("button", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translate('pullData')), 1),
                      _createElementVNode("span", _hoisted_12, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_13
                      ])
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "url" })
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema", "onSubmit"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.newsSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.translate('arabicTitle')), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('arabicTitle'),
                      modelValue: _ctx.news.titleAr,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.news.titleAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.translate('englishTitle')), 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('englishTitle'),
                      modelValue: _ctx.news.titleEn,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.news.titleEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('arabicDescription')), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "descriptionAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('arabicDescription'),
                      modelValue: _ctx.news.descriptionAr,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.news.descriptionAr) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.translate('englishDescription')), 1),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "descriptionEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('englishDescription'),
                      modelValue: _ctx.news.descriptionEn,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.news.descriptionEn) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_ErrorMessage, { name: "descriptionEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.translate('date')) + ": ", 1),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_Field, {
                      type: "date",
                      name: "date",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      modelValue: _ctx.news.date,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.news.date) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createVNode(_component_ErrorMessage, { name: "date" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.translate('readTime')), 1),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "readTime",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('readTime'),
                      modelValue: _ctx.news.readTime,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.news.readTime) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_ErrorMessage, { name: "readTime" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.translate('externalLink')), 1),
                  _createElementVNode("div", _hoisted_50, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "externalLink",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('externalLink')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_ErrorMessage, { name: "externalLink" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.translate('imageUrl')), 1),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_Field, {
                      as: "textarea",
                      name: "thumbnail",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('imageUrl'),
                      modelValue: _ctx.news.image,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.news.image) = $event)),
                      onInput: _ctx.handleImageUrlChange
                    }, null, 8, ["placeholder", "modelValue", "onInput"]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_ErrorMessage, { name: "thumbnail" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.translate('logo')) + ": ", 1),
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      ref: "fileInput",
                      class: "form-control form-control-lg form-control-solid",
                      onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                    }, null, 544),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_ErrorMessage, { name: "logo" })
                      ])
                    ])
                  ])
                ]),
                (_ctx.previewImage || _ctx.news.image)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.translate('image')), 1),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("img", {
                          class: "w-200px h-200px",
                          src: _ctx.previewImage || _ctx.news.image
                        }, null, 8, _hoisted_66)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_68, [
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_70, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_71
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}